export default __webpack_public_path__ + "media/images/tenant/howToRentApartment/step_4-48ca6a945f4d63c81be150f9c8c765ca.jpg";